import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { getCampaignVehicles } from '@/redux/Campaign/campaign.reducer';
import { AffectedVehicles, LimitationPlant } from '@/types';
import ModelSeriesAccordions from '../VehicleCleanDirt/ModelSeriesAccordions';
import styles from '../VolumeDetails.module.scss';

type SummaryVehiclesCleanDirtProps = {
  affectedVehicles: AffectedVehicles;
  plantWkz: string;
};

const SummaryVehiclesCleanDirt: React.FC<SummaryVehiclesCleanDirtProps> = ({ affectedVehicles, plantWkz }) => {
  const { t } = useTranslation();
  const plantSelected = affectedVehicles.affectedPlants?.find((plant: LimitationPlant) => (plant.wkzNumber === plantWkz)) || {};

  return (
    <div className={styles.NokOk}>
      <strong>{t('VehicleCleanDirt.cleanDirtCriteria')}</strong>
      <ModelSeriesAccordions disabled plantSelected={plantSelected} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  affectedVehicles: getCampaignVehicles(state),
});

export default connect(mapStateToProps)(SummaryVehiclesCleanDirt);
